import React from 'react';

/** Grille de filtres extraite de SecurityLogs.tsx (type / sévérité / user / IP / dates). */

export interface SecurityLogsFiltersPanelProps {
  filters: {
    type: string;
    severity: string;
    user_id: string;
    ip_address: string;
    start_date: string;
    end_date: string;
  };
  onChange: (key: string, value: string) => void;
}

const SecurityLogsFiltersPanel: React.FC<SecurityLogsFiltersPanelProps> = ({
  filters,
  onChange,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 pt-4 border-t border-gray-700/50">
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">Type d'événement</label>
      <select
        value={filters.type}
        onChange={(e) => onChange('type', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
      >
        <option value="">Tous les types</option>
        <option value="auth_failure">🔐 Échec d'authentification</option>
        <option value="auth_success">✅ Authentification réussie</option>
        <option value="rate_limit_exceeded">⏱️ Limite dépassée</option>
        <option value="unauthorized_access">🚫 Accès non autorisé</option>
        <option value="suspicious_activity">⚠️ Activité suspecte</option>
        <option value="invalid_token">🔑 Token invalide</option>
        <option value="permission_denied">🚪 Permission refusée</option>
      </select>
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">Niveau de sévérité</label>
      <select
        value={filters.severity}
        onChange={(e) => onChange('severity', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
      >
        <option value="">Tous les niveaux</option>
        <option value="critical">🔴 Critique</option>
        <option value="high">🟠 Élevée</option>
        <option value="medium">🟡 Moyenne</option>
        <option value="low">🟢 Faible</option>
      </select>
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">ID Utilisateur</label>
      <input
        type="number"
        value={filters.user_id}
        onChange={(e) => onChange('user_id', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
        placeholder="Ex: 123"
      />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">Adresse IP</label>
      <input
        type="text"
        value={filters.ip_address}
        onChange={(e) => onChange('ip_address', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all font-mono text-sm"
        placeholder="192.168.1.1"
      />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">Date début</label>
      <input
        type="date"
        value={filters.start_date}
        onChange={(e) => onChange('start_date', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
      />
    </div>
    <div>
      <label className="block text-sm font-medium text-gray-300 mb-2">Date fin</label>
      <input
        type="date"
        value={filters.end_date}
        onChange={(e) => onChange('end_date', e.target.value)}
        className="w-full px-4 py-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all"
      />
    </div>
  </div>
);

export default SecurityLogsFiltersPanel;
